import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { List, Map, fromJS } from 'immutable';
import { PieChart, Pie, LabelList, Cell, Sector } from 'recharts';

import { Icon, Progress, Dimmer, Label, Image, Popup } from 'semantic-ui-react';
import { IconButton, Tooltip } from 'material-ui';
import { DetailTemplate, Button, MaterialSnackbar, Loading, LeakCountInfo, InfectionPC } from 'components';

import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import styles from './ExamDetail.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamDetail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const {
      selectedDetailData,
      // 감염 대상
      infectionTarget,
      // 감염 PC
      infectionPC,
      // 감염대상 로딩
      isLoadingTarget,
      // 감염 PC 로딩
      isLoadingPC,
      // 교육 이력
      eduList,
      // 교육 이력 로딩
      isLoadingEdu,
      isSnackbar
    } = this.props;
    // function
    const {
      onMoveScroll,
      onRefRegister,
      onToggleSnackbar,
      onToggleDetailView,
      // [감염 대상] 열기 닫기
      onToggleInfectionTarget,
      // 감염 대상 조회
      onGetInfectionFile,
      // 감염 PC 조회
      onGetInfectionPC,
      // 교육 이력 조회
      onGetEduHistory
    } = this.props;

    // ---------------------------------- 훈련 정보 ----------------------------------
    let detailData = Map({
      examNo: 0,
      examName: '-',
      examTagTarget: '-',
      examStartEpoch: 0,
      examEndEpoch: 0,
      target: 0,
      send: 0,
      read: 0,
      download: 0,
      cure: 0,
      infection: 0,
      infectionPc: 0,
      declare: 0,
      edu: 0,
      eduTarget: 0,
      eduBefore: 0,
      eduPlay: 0,
      eduAfter: 0,
      leakAllcount: 0,
      leakAllsize: 0,
      leakFileCount: 0,
      leakFileSize: 0,
      leakCertCount: 0,
      leakCertSize: 0,
      leakEmailCount: 0,
      leakEmailSize: 0,
      serviceTemplateNo: 0,
      templateName: '',
      templatePick: 0,
      createUser: 0,
      userName: '',
      userEmail: '',
      serviceNo: 0,
      rnum: 0,
      regEpoch: 0,
      modifyEpoch: 0,
      linkAttach: 1,
      examType: 0,
      attachScreenType: 0
    });

    // 데이터가 없는 경우
    let isNoData = false;
    if (!!selectedDetailData) {
      detailData = selectedDetailData;
    } else {
      isNoData = true;
    }

    // 상세 페이지 타입
    const isViewType = detailData.get('examNo') !== 0 ? true : false;

    // 피싱 유도 타입의 훈련 양식
    const isPhishing = 4 === detailData.get('examType') ? true : false;

    // 디테일 표시 내용
    const btDatas = [
      {
        id: 'move-info',
        iconName: 'list',
        content: defineMessages(formatMessage({ id: 'ExamDetail_1', defaultMessage: '훈련 정보' })),
        isView: true
      },
      {
        id: 'move-infectionFile',
        iconName: 'file text outline',
        content: defineMessages(formatMessage({ id: 'ExamDetail_2', defaultMessage: '감염 가능 파일' })),
        isView: isPhishing ? false : true
      },
      {
        id: 'move-target',
        iconName: 'user',
        content: defineMessages(formatMessage({ id: 'ExamDetail_3', defaultMessage: '감염 대상' })),
        isView: isPhishing ? false : true
      },
      {
        id: 'move-pc',
        iconName: 'desktop',
        content: defineMessages(formatMessage({ id: 'ExamDetail_4', defaultMessage: '감염 PC' })),
        isView: isPhishing ? false : true
      }
    ];

    // 상태
    let examStatus = (
      <div className={cx('bold', 'brand-green')}>
        {defineMessages(formatMessage({ id: 'ExamDetail_7', defaultMessage: '양호' }))}
      </div>
    );
    if (detailData.get('infection') > 0) {
      let infectionPercent = (detailData.get('infection') / detailData.get('target') * 100).toFixed(0);
      if (detailData.get('infection') > 0 && infectionPercent === 0) {
        infectionPercent = 1;
      }

      examStatus = (
        <div className={cx('color-red')}>
          <span className={cx('bold')}>
            {defineMessages(formatMessage({ id: 'ExamDetail_5', defaultMessage: '위험' }))}
          </span>
          <span className={cx('font-size-12')}>
            {isPhishing
              ? ' (' +
                defineMessages(formatMessage({ id: 'ExamDetail_54', defaultMessage: '정보 유출률' })) +
                ' ' +
                infectionPercent +
                '%)'
              : ' (' +
                defineMessages(formatMessage({ id: 'ExamDetail_8', defaultMessage: '감염율' })) +
                ' ' +
                infectionPercent +
                '%)'}
          </span>
        </div>
      );
    } else if (!!detailData.get('download') && detailData.get('download') > 0) {
      examStatus = (
        <div className={cx('color-red')}>
          <span className={cx('bold')}>
            {isPhishing
              ? defineMessages(formatMessage({ id: 'ExamDetail_53', defaultMessage: '경고 (피싱 접속 대상자 있음)' }))
              : defineMessages(
                  formatMessage({ id: 'ExamDetail_46', defaultMessage: '경고 (파일을 다운로드한 대상자 있음)' })
                )}
          </span>
        </div>
      );
    } else if (detailData.get('read') > 0) {
      examStatus = (
        <div className={cx('bold', 'color-orange')}>
          {defineMessages(formatMessage({ id: 'ExamDetail_6', defaultMessage: '주의 (메일 열람 대상자 있음)' }))}
        </div>
      );
    }

    let progress = 0;
    // 예약 훈련
    let isReserveExam = false;

    if (!!isViewType) {
      if (detailData.get('examStartEpoch') > common.nowEpoch()) {
        isReserveExam = true;
      } else {
        progress = Math.round(
          (common.nowEpoch() - Number(detailData.get('examStartEpoch'))) /
            (Number(detailData.get('examEndEpoch')) - Number(detailData.get('examStartEpoch'))) *
            100
        );

        // 만약 훈련 진행중인데 1%가 안되어도 1%로 표기
        progress = 1 > progress ? 1 : progress;
      }
    }

    // 첨부파일 정보
    let AttachInfoComponent = <span className={cx('examInfo-content')}>-</span>;
    const aData = detailData.getIn(['attachData']);

    if (aData) {
      const attachFunctionKey = aData.get('attachFunction') && Object.keys(JSON.parse(aData.get('attachFunction')));
      let attachFunction = '-';
      if (aData.get('attachFunction') && attachFunctionKey.length > 0) {
        attachFunction = attachFunctionKey.map((keys, i) => {
          return (
            <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachFunction')}>
              {keys}
            </Label>
          );
        });
      }

      const attachRestrictKey = aData.get('attachRestrict') && Object.keys(JSON.parse(aData.get('attachRestrict')));
      let attachRestrict = '-';

      if (aData.get('attachRestrict') && attachRestrictKey.length > 0) {
        attachRestrict = attachRestrictKey.map((keys, i) => {
          return (
            <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachRestrict')}>
              {keys}
            </Label>
          );
        });
      }

      AttachInfoComponent = (
        <Popup
          className={cx('temp-attachCellPopup')}
          trigger={<span className={cx('examInfo-content')}>{detailData.getIn(['attachData', 'subject'])}</span>}
          position="right center">
          <div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>No</span>
              <span className={cx('temp-attachCellPopup-content')}>{aData.get('attachInfoNo')}</span>
            </div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>
                {defineMessages(formatMessage({ id: 'ExamAttachAdd_18', defaultMessage: '구분' }))}
              </span>
              <span className={cx('temp-attachCellPopup-content')}>
                {aData.get('attachCategory') === 1 && (
                  <Label basic size="small" className={cx('template-type-label color-attach-exe')}>
                    {defineMessages(formatMessage({ id: 'ExamAttachList_15', defaultMessage: '실행파일' }))}
                  </Label>
                )}
                {aData.get('attachCategory') === 2 && (
                  <Label basic size="small" className={cx('template-type-label color-attach-lnk')}>
                    {defineMessages(formatMessage({ id: 'ExamAttachList_16', defaultMessage: '바로가기' }))}
                  </Label>
                )}
                {aData.get('attachCategory') === 3 && (
                  <Label basic size="small" className={cx('template-type-label color-attach-doc')}>
                    {defineMessages(formatMessage({ id: 'ExamAttachList_17', defaultMessage: '문서파일' }))}
                  </Label>
                )}
                {aData.get('attachCategory') === 4 && (
                  <Label basic size="small" className={cx('template-type-label color-attach-html')}>
                    {defineMessages(formatMessage({ id: 'ExamAttachList_18', defaultMessage: '웹문서' }))}
                  </Label>
                )}
              </span>
            </div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
              </span>
              <span className={cx('temp-attachCellPopup-content')}>
                {aData.get('attachExamType') === 1 && (
                  <Label basic size="small" className={cx('template-type-label color-temp-warning')}>
                    {defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' }))}
                  </Label>
                )}
                {aData.get('attachExamType') === 2 && (
                  <Label basic size="small" className={cx('template-type-label color-temp-file')}>
                    {defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' }))}
                  </Label>
                )}
                {aData.get('attachExamType') === 3 && (
                  <Label basic size="small" className={cx('template-type-label color-temp-research')}>
                    {defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' }))}
                  </Label>
                )}
              </span>
            </div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>
                {defineMessages(formatMessage({ id: 'ExamAttachList_3', defaultMessage: '아이콘' }))}
              </span>
              <span className={cx('temp-attachCellPopup-content')}>
                <Image
                  className={cx('attach-fileIcon')}
                  src={'/fdata/attachFile/' + aData.get('attachInfoNo') + '/' + aData.get('fileIcon')}
                />
              </span>
            </div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>
                {defineMessages(formatMessage({ id: 'ExamAttachList_4', defaultMessage: '확장자' }))}
              </span>
              <span className={cx('temp-attachCellPopup-content')}>{aData.get('fileExt')}</span>
            </div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>
                {defineMessages(formatMessage({ id: 'ExamAttachAdd_19', defaultMessage: '부가 기능' }))}
              </span>
              <span className={cx('temp-attachCellPopup-content')}>{attachFunction}</span>
            </div>
            <div className={cx('temp-attachCellPopup-each')}>
              <span className={cx('temp-attachCellPopup-title')}>
                {defineMessages(formatMessage({ id: 'ExamAttachAdd_20', defaultMessage: '제약 사항' }))}
              </span>
              <span className={cx('temp-attachCellPopup-content')}>{attachRestrict}</span>
            </div>
          </div>
        </Popup>
      );
    }

    // ---------------------------------- 감염 가능 파일 ----------------------------------
    const infectionFileArray = [
      // 데이터가 없을때 표시
      {
        name: '',
        color: '',
        value: detailData.get('leakAllcount') > 0 ? 0 : 100,
        file: '',
        label: '',
        percent: detailData.get('leakAllcount') > 0 ? 0 : 100,
        percentLabel: ''
      },
      {
        name: 'pc',
        color: '#43cbaa',
        value: detailData.get('leakFileCount'),
        file: detailData.get('leakFileSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetail_9', defaultMessage: 'PC 파일' })),
        percent: (detailData.get('leakFileCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakFileCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      },
      {
        name: 'cert',
        color: '#7b3faf',
        value: detailData.get('leakCertCount'),
        file: detailData.get('leakCertSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetail_10', defaultMessage: '인증서' })),
        percent: (detailData.get('leakCertCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakCertCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      },
      {
        name: 'email',
        color: '#6697da',
        value: detailData.get('leakEmailCount'),
        file: detailData.get('leakEmailSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetail_11', defaultMessage: '이메일' })),
        percent: (detailData.get('leakEmailCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakEmailCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      }
    ];
    const InfectionFile = (
      <div className={cx('infectFile-area')}>
        <div className={cx('examInfo')}>
          <span className={cx('allCount')}>
            {defineMessages(formatMessage({ id: 'ExamDetail_13', defaultMessage: '총 ' })) + ' '}
            {detailData.get('leakAllcount')}
            {defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
          </span>
          <span className={cx('allSize')}>({common.fileSizeTrans(detailData.get('leakAllsize')).common})</span>
        </div>
        <div className={cx('infectFile-item')}>
          <div>
            <PieChart width={130} height={130}>
              <Pie
                dataKey="value"
                data={[
                  {
                    name: 'background',
                    value: 100
                  }
                ]}
                cx={60}
                cy={60}
                paddingAngle={0}
                innerRadius={20}
                outerRadius={55}>
                <Cell fill="#f7f7f7" />
              </Pie>
              <Pie
                dataKey="value"
                data={infectionFileArray}
                cx={60}
                cy={60}
                innerRadius={25}
                outerRadius={50}
                startAngle={450}
                endAngle={90}
                paddingAngle={-1}
                activeIndex={0}
                activeShape={e => {
                  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = e;
                  return (
                    <g>
                      {/* 그라데이션 효과 */}
                      {/* 파일 */}
                      <defs>
                        <linearGradient id="43cbaa" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#39cbd2" />
                          <stop offset="50%" stopColor="#77eadf" />
                          <stop offset="100%" stopColor="#28c3a4" />
                        </linearGradient>
                      </defs>
                      {/* 인증서 */}
                      <defs>
                        <linearGradient id="7b3faf" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#753eaa" />
                          <stop offset="50%" stopColor="#a33ede" />
                          <stop offset="100%" stopColor="#6e19cc" />
                        </linearGradient>
                      </defs>
                      {/* 이메일 */}
                      <defs>
                        <linearGradient id="6697da" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#619dd8" />
                          <stop offset="100%" stopColor="#6649d2" />
                        </linearGradient>
                      </defs>

                      {/* 차트의 기본 형태 영역 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        fill="rgb(230,230,230)"
                      />
                      {/* 차트의 확장 처리 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        innerRadius={outerRadius - 1}
                        outerRadius={outerRadius + 8}
                        fill="rgb(230,230,230)"
                      />
                    </g>
                  );
                }}>
                {/* cell 안에 그라데이션 효과 */}
                {infectionFileArray.map((entry, index) => <Cell key={index} fill={'url(' + entry.color + ')'} />)}
              </Pie>
              <Tooltip
                content={({ payload }) => {
                  return payload.map((entry, index) => {
                    if (entry.name === 'pc' || entry.name === 'cert' || entry.name === 'email') {
                      return (
                        <div className={cx('chart2-tooltip')} key={index}>
                          <div className={cx('name')}>{entry.payload.label}</div>
                          <div className={cx('value')}>
                            {entry.value +
                              defineMessages(formatMessage({ id: 'ExamHeader_2', defaultMessage: '개' })) +
                              ' (' +
                              entry.payload.file +
                              ')'}
                          </div>
                        </div>
                      );
                    }
                  });
                }}
              />
            </PieChart>
          </div>
          <div className={cx('examDetail-infectionFile')}>
            <span className={cx('examDetail-legend')}>
              {infectionFileArray.map(
                (entry, index) =>
                  !!entry.name && (
                    <div className={cx('examInfo')} key={index}>
                      <span className={cx('examInfo-title')}>
                        <Icon name="circle" style={{ color: entry.color }} />
                        {entry.label}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {entry.value}
                        {defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                        {' (' + common.fileSizeTrans(entry.file).common + ')'}
                      </span>
                    </div>
                  )
              )}
            </span>
          </div>
        </div>
      </div>
    );

    // ---------------------------------- 감염 대상 ----------------------------------
    const InfectionTargetComponent =
      (infectionTarget.get('data').size === 0 && (
        <div className={cx('brand-green')}>
          <Icon name="checkmark box" />
          {defineMessages(formatMessage({ id: 'ExamDetail_14', defaultMessage: '감염 대상 없음' }))}
        </div>
      )) ||
      infectionTarget.get('data').map((target, index) => (
        <div key={index} className={cx('infection-set')}>
          <div className={cx('infection-summary')}>
            <div className={cx('infection-title')}>
              <Tooltip
                title={target.get('targetName') + ' (' + target.get('targetEmail') + ')'}
                placement="bottom-start">
                <div className={cx('target-name ellipsis')}>
                  {target.get('targetName') + ' (' + target.get('targetEmail') + ')'}
                </div>
              </Tooltip>
              <IconButton
                color="primary"
                className={cx('bt-toggleView')}
                onClick={e => {
                  e.stopPropagation();
                  onToggleInfectionTarget(target.get('targetNo'));
                }}>
                <Image
                  src={
                    infectionTarget.get('isOpen').indexOf(target.get('targetNo')) !== -1
                      ? '/img/target/ico_close.png'
                      : '/img/target/ico_open.png'
                  }
                />
              </IconButton>
            </div>
            <div className={cx('infection-content')}>
              <div
                className={cx('target-info')}
                title={
                  (!!target.get('targetDivision') ? target.get('targetDivision') : '-') +
                  ' / ' +
                  (!!target.get('targetPosition') ? target.get('targetPosition') : '-')
                }>
                <div className={cx('targetDivision ellipsis')}>
                  {!!target.get('targetDivision') ? target.get('targetDivision') : '-'}
                </div>
                /
                <div className={cx('targetPosition ellipsis')}>
                  {!!target.get('targetPosition') ? target.get('targetPosition') : '-'}
                </div>
              </div>
              <div className={cx('pc-info-area')}>
                <InfectionPC
                  pcCount={target.get('infectionPc') ? target.get('infectionPc').size : 0}
                  leakCount={target.get('leakAllcount')}
                  leakSize={common.fileSizeTrans(target.get('leakAllsize')).common}
                  size={'s'}
                />
                <LeakCountInfo
                  formatMessage={formatMessage}
                  type="all"
                  count={target.get('leakAllcount')}
                  size={target.get('leakAllsize')}
                />
              </div>
            </div>
          </div>

          {/* 감염대상 상세 */}
          {infectionTarget.get('isOpen').indexOf(target.get('targetNo')) !== -1 && (
            <div className={cx('infection-detail')}>
              <div className={cx('detailInner-area')}>
                <div className={cx('bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_18', defaultMessage: '대상자 정보' }))}
                </div>
                <div className={cx('detailContent-area')}>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_19', defaultMessage: '번호' }))}
                    </div>
                    <div className={cx('detail-content')}>{target.get('targetNo')}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_20', defaultMessage: '이름' }))}
                    </div>
                    <div className={cx('detail-content')}>{target.get('targetName')}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_21', defaultMessage: '메일' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {target.get('targetEmail') ? target.get('targetEmail') : '-'}
                    </div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_15', defaultMessage: '소속' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {target.get('targetDivision') ? target.get('targetDivision') : '-'}
                    </div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_16', defaultMessage: '직급' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {target.get('targetPosition') ? target.get('targetPosition') : '-'}
                    </div>
                  </div>
                </div>
              </div>
              <div className={cx('detailInner-area mt-10')}>
                <div className={cx('bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_22', defaultMessage: '일시' }))}
                </div>
                <div className={cx('detailContent-area')}>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_23', defaultMessage: '메일 발송' }))}
                    </div>
                    <div className={cx('detail-content')}>{common.timeFormatFromUTCEpoch(target.get('sendEpoch'))}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_24', defaultMessage: '메일 확인' }))}
                    </div>
                    <div className={cx('detail-content')}>{common.timeFormatFromUTCEpoch(target.get('readEpoch'))}</div>
                  </div>
                  {(2 & target.get('linkAttach') || isPhishing) && (
                    <div className={cx('targetExam-item')}>
                      <div className={cx('detail-title')}>
                        {defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      </div>
                      <div className={cx('detail-content')}>
                        {common.timeFormatFromUTCEpoch(target.get('downloadEpoch'))}
                      </div>
                    </div>
                  )}
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_25', defaultMessage: '감염 파일 실행' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {common.timeFormatFromUTCEpoch(target.get('infectionEpoch'))}
                    </div>
                  </div>
                  {/* 모의 악성파일 */}
                  {1 === target.get('examType') &&
                    2 === detailData.getIn(['attachData', 'attachExamType']) && (
                      <div className={cx('targetExam-item')}>
                        <div className={cx('detail-title')}>
                          {defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' }))}
                        </div>
                        <div className={cx('detail-content')}>
                          {common.timeFormatFromUTCEpoch(target.get('cureEpoch'))}
                        </div>
                      </div>
                    )}
                </div>
              </div>
              {target.get('infectionPc') && (
                <div className={cx('detailInner-area mt-10')}>
                  <div className={cx('bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetail_26', defaultMessage: '감염 정보' }))}
                  </div>
                  <div className={cx('infection-info')}>
                    <InfectionPC
                      pcCount={target.get('infectionPc').size}
                      size={'s'}
                      leakCount={target.get('leakAllcount')}
                      leakSize={common.fileSizeTrans(target.get('leakAllsize')).common}
                      noTooltip
                    />
                    <div className={cx('count-area')}>
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="all"
                        count={target.get('leakAllcount')}
                        size={target.get('leakAllsize')}
                      />
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="file"
                        count={target.get('leakFileCount')}
                        size={target.get('leakFileSize')}
                      />
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="cert"
                        count={target.get('leakCertCount')}
                        size={target.get('leakCertSize')}
                      />
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="mail"
                        count={target.get('leakEmailCount')}
                        size={target.get('leakEmailSize')}
                      />
                    </div>
                  </div>
                </div>
              )}
              {target.get('infectionPc') && (
                <div className={cx('detailInner-area', 'mt-10')}>
                  <div className={cx('bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetail_27', defaultMessage: '감염 PC 목록' }))}
                  </div>
                  <div className={cx('infectionPc-content')}>
                    {target.get('infectionPc').map((pcData, index) => (
                      <div key={index} className={cx('infectionPc-item')}>
                        <div
                          className={cx('pc-info', 'ellipsis')}
                          title={pcData.get('hostname') + ' (' + pcData.get('ip') + ')'}>
                          <span className={cx('bold mr-5')}>·</span>
                          <span>{pcData.get('hostname') + ' (' + pcData.get('ip') + ')'}</span>
                        </div>
                        <div className={cx('date-info')}>
                          <span>
                            {defineMessages(formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' }))}
                          </span>
                          <span className={cx('date-text')}>
                            {common.timeFormatFromUTCEpoch(pcData.get('regEpoch'), 1)}
                          </span>
                        </div>
                        <div className={cx('count-area ml-5')}>
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="all"
                            count={pcData.get('leakAllcount')}
                            size={pcData.get('leakAllsize')}
                          />
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="file"
                            count={pcData.get('leakFileCount')}
                            size={pcData.get('leakFileSize')}
                          />
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="cert"
                            count={pcData.get('leakCertCount')}
                            size={pcData.get('leakCertSize')}
                          />
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="mail"
                            count={pcData.get('leakEmailCount')}
                            size={pcData.get('leakEmailSize')}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ));

    // ---------------------------------- 감염 PC ----------------------------------
    const InfectionPcComponent =
      (infectionPC.get('data').size === 0 && (
        <div className={cx('brand-green')}>
          <Icon name="checkmark box" />
          {defineMessages(formatMessage({ id: 'ExamDetail_28', defaultMessage: '감염 PC 없음' }))}
        </div>
      )) ||
      infectionPC.get('data').map((pc, index) => (
        <div className={cx('infectionPc-set')} key={index}>
          <div className={cx('pc-info-area ellipsis')}>
            <div className={cx('pc-info', 'ellipsis')}>
              <span className={cx('bold mr-5')}>·</span>
              <span className={cx('pc')}>{pc.get('hostname')}</span>
              <span className={cx('ip')}>{' (' + pc.get('ip') + ')'}</span>
            </div>
            <div className={cx('date-info')}>
              <span>{defineMessages(formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' }))}</span>
              <span className={cx('date-text')}>{common.timeFormatFromUTCEpoch(pc.get('regEpoch'), 1)}</span>
            </div>
            <div
              className={cx('date-info', 'ellipsis')}
              title={pc.get('targetName') + ' (' + pc.get('targetEmail') + ')'}>
              <span className={cx('target')}>{pc.get('targetName')}</span>
              <span className={cx('mail')}>{' (' + pc.get('targetEmail') + ')'}</span>
            </div>
          </div>
          <div className={cx('count-area ml-5')}>
            <LeakCountInfo
              formatMessage={formatMessage}
              type="all"
              count={pc.get('leakAllcount')}
              size={pc.get('leakAllsize')}
            />
            <LeakCountInfo
              formatMessage={formatMessage}
              type="file"
              count={pc.get('leakFileCount')}
              size={pc.get('leakFileSize')}
            />
            <LeakCountInfo
              formatMessage={formatMessage}
              type="cert"
              count={pc.get('leakCertCount')}
              size={pc.get('leakCertCount')}
            />
            <LeakCountInfo
              formatMessage={formatMessage}
              type="mail"
              count={pc.get('leakEmailCount')}
              size={pc.get('leakEmailSize')}
            />
          </div>
        </div>
      ));

    // 교육 이력
    const EduListComponent =
      (eduList.get('data').size === 0 && (
        <div className={cx('brand-green')}>
          <Icon name="checkmark box" />
          {defineMessages(formatMessage({ id: 'Edu_33', defaultMessage: '학습 대상 없음' }))}
        </div>
      )) ||
      eduList.get('data').map((eduData, index) => (
        <div className={cx('infectionPc-set')} key={index}>
          <div className={cx('pc-info-area ellipsis')}>
            <div className={cx('pc-info', 'ellipsis')}>
              <span className={cx('bold mr-5')}>·</span>
              <Tooltip title={eduData.get('eduName')} placement="top">
                <span className={cx('pc')}>{eduData.get('eduName')}</span>
              </Tooltip>
            </div>
            <div className={cx('date-info')}>
              <span>{defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '컨텐츠' }))}</span>
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '컨텐츠' })) +
                  ': ' +
                  eduData.get('attachName')
                }
                placement="top">
                <span className={cx('date-text')}>{eduData.get('attachName')}</span>
              </Tooltip>
            </div>
            <div className={cx('date-info')}>
              <span>{defineMessages(formatMessage({ id: 'Edu_2', defaultMessage: '교육 기간' }))}</span>
              <span className={cx('date-text')}>
                {common.timeFormatFromUTCEpoch(eduData.get('startEpoch'), 3) +
                  ' ~ ' +
                  common.timeFormatFromUTCEpoch(eduData.get('endEpoch'), 3)}
              </span>
            </div>
          </div>
          <div className={cx('count-area ml-5')}>
            <LeakCountInfo
              edu
              formatMessage={formatMessage}
              type="all"
              count={eduData.get('eduCount')}
              tooltip={
                defineMessages(formatMessage({ id: 'Edu_21', defaultMessage: '교육 대상자' })) +
                ': ' +
                eduData.get('eduCount')
              }
            />
            <LeakCountInfo
              edu
              formatMessage={formatMessage}
              type="edu-wait"
              count={eduData.get('beforeCount')}
              tooltip={
                defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '학습 진행 전 대상자' })) +
                ': ' +
                eduData.get('beforeCount')
              }
            />
            <LeakCountInfo
              edu
              formatMessage={formatMessage}
              type="edu-ing"
              count={eduData.get('playCount')}
              tooltip={
                defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '학습 진행 중인 대상자' })) +
                ': ' +
                eduData.get('playCount')
              }
            />
            <LeakCountInfo
              edu
              formatMessage={formatMessage}
              type="edu-finish"
              count={eduData.get('afterCount')}
              tooltip={
                defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '학습 완료 대상자' })) +
                ': ' +
                eduData.get('afterCount')
              }
            />
          </div>
        </div>
      ));

    return (
      <DetailTemplate btDatas={btDatas} onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        {/* ------------------------------------- 데이터가 없을 경우 ------------------------------------ */}
        {!!isNoData && (
          <Dimmer active inverted className={cx('isNoData')}>
            <div className={cx('isNoData-content')}>
              {/* <Icon name="pointing up" /> */}
              <Image className={cx('mr-5 info-select-icon')} src="/img/exam/info_select.png" />
              <div className={cx('text')}>
                {defineMessages(formatMessage({ id: 'ExamDetail_29', defaultMessage: '훈련을 선택하세요.' }))}
              </div>
            </div>
          </Dimmer>
        )}
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper')}>
            {/* ----------------------------------------- 훈련 정보 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-info')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-info', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetail_30', defaultMessage: '훈련 정보' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_31', defaultMessage: '훈련 번호' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('examNo')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_32', defaultMessage: '훈련명' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('examName')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_33', defaultMessage: '상태' }))}
                    </span>
                    <div className={cx('examInfo-content')}>{examStatus}</div>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_34', defaultMessage: '진행률' }))}
                    </span>
                    <div
                      className={cx('examInfo-content display-flex', { expansionBar: progress > 9 && progress < 16 })}>
                      {isReserveExam && (
                        <Tooltip
                          title={defineMessages(formatMessage({ id: 'ExamSummary_10', defaultMessage: '예약 훈련' }))}
                          placement="top">
                          <Image className={cx('mr-5')} src="/img/exam/cate_reserve.png" />
                        </Tooltip>
                      )}
                      <Progress
                        percent={progress}
                        size="small"
                        progress
                        inverted
                        indicating
                        disabled={isReserveExam ? true : false}
                      />
                    </div>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_35', defaultMessage: '훈련 기간' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {common.timeFormatFromUTCEpoch(detailData.get('examStartEpoch'), 3)}
                      &nbsp;~&nbsp;
                      {common.timeFormatFromUTCEpoch(detailData.get('examEndEpoch'), 3)}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_36', defaultMessage: '템플릿' }))}
                    </span>
                    <div className={cx('examInfo-content')}>
                      {detailData.get('templatePick') === 1 ? (
                        <Label basic size="small" className={cx('template-user-label color-temp-user')}>
                          {defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }))}
                        </Label>
                      ) : (
                        <Label basic size="small" className={cx('template-user-label color-temp-system')}>
                          {defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }))}
                        </Label>
                      )}
                      {1 === detailData.get('examType') &&
                        1 === detailData.getIn(['attachData', 'attachExamType']) && (
                          <Label basic size="small" className={cx('template-type-label color-temp-warning')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_49', defaultMessage: '경고 안내' }))}
                          </Label>
                        )}
                      {1 === detailData.get('examType') &&
                        2 === detailData.getIn(['attachData', 'attachExamType']) && (
                          <Label basic size="small" className={cx('template-type-label color-temp-file')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_50', defaultMessage: '모의 악성파일' }))}
                          </Label>
                        )}
                      {1 === detailData.get('examType') &&
                        3 === detailData.getIn(['attachData', 'attachExamType']) && (
                          <Label basic size="small" className={cx('template-type-label color-temp-research')}>
                            {defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' }))}
                          </Label>
                        )}
                      {4 === detailData.get('examType') && (
                        <Label basic size="small" className={cx('template-type-label color-temp-phishing')}>
                          {defineMessages(formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' }))}
                        </Label>
                      )}
                      <div className={cx('tempName')}>
                        {'('}
                        {1 === detailData.get('linkAttach') &&
                          defineMessages(formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' }))}
                        {2 === detailData.get('linkAttach') &&
                          defineMessages(formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' }))}
                        {3 === detailData.get('linkAttach') &&
                          defineMessages(formatMessage({ id: 'ExamTemplateList_31', defaultMessage: '링크 + 첨부' }))}
                        {') / ' + detailData.get('templateName')}
                      </div>
                    </div>
                  </div>
                  {!isPhishing && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        <Popup
                          trigger={
                            <a
                              href={'/attachRestrict_' + localStorage.getItem('language') + '.html'}
                              target="restrict"
                              className={cx('charcoal')}
                              onClick={e => e.stopPropagation()}>
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateList_33', defaultMessage: '첨부파일 정보' })
                              )}
                              <Icon name="info circle" className={cx('ml-5')} />
                            </a>
                          }>
                          {defineMessages(
                            formatMessage({
                              id: 'ExamAttachList_19',
                              defaultMessage: "부가기능, 제약사항 설명 페이지 'Click!'"
                            })
                          )}
                        </Popup>
                      </span>
                      {AttachInfoComponent}
                    </div>
                  )}
                  {detailData.get('sendReservePeriod') && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'ExamDetail_47', defaultMessage: '훈련 메일 나눔 발송' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {common.timeFormatFromUTCEpoch(detailData.get('examStartEpoch'), 3) +
                          ' ~ ' +
                          common.timeFormatFromUTCEpoch(
                            // 시작일에서 n일 후
                            detailData.get('examStartEpoch') + (detailData.get('sendReservePeriod') - 1) * 86400,
                            3
                          ) +
                          ' (' +
                          detailData.get('sendReserveStartHour') +
                          defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' })) +
                          ' ~ ' +
                          detailData.get('sendReserveEndHour') +
                          defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' })) +
                          ')'}
                      </span>
                    </div>
                  )}
                  {!isPhishing &&
                    detailData.get('attachScreenLockEpoch') && (
                      <div className={cx('examInfo')}>
                        <span className={cx('examInfo-title')}>
                          {defineMessages(
                            formatMessage({ id: 'ExamDetail_48', defaultMessage: '화면 잠금 예약 일시' })
                          )}
                        </span>
                        <span className={cx('examInfo-content')}>
                          {common.timeFormatFromUTCEpoch(detailData.get('attachScreenLockEpoch'), 2)}
                        </span>
                      </div>
                    )}
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_37', defaultMessage: '훈련 실시자' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('userName') + '(' + detailData.get('userEmail') + ')'}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_38', defaultMessage: '훈련 대상' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('target') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      {detailData.get('examTargetRandomPer') < 100
                        ? ' (' +
                          defineMessages(
                            formatMessage({ id: 'StartExam_11', defaultMessage: '훈련 대상자 선택 비율' })
                          ) +
                          ' ' +
                          detailData.get('examTargetRandomPer') +
                          '%)'
                        : ''}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_39', defaultMessage: '발송' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('isSuspend') === 1 &&
                        '(' +
                          defineMessages(
                            formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })
                          ) +
                          ') '}
                      {detailData.get('send') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      {detailData.get('send') + detailData.get('sendError') < detailData.get('target') &&
                        ' (' +
                          defineMessages(formatMessage({ id: 'ExamHeader_21', defaultMessage: '진행중' })) +
                          ': ' +
                          (
                            (detailData.get('send') + detailData.get('sendError')) /
                            detailData.get('target') *
                            100
                          ).toFixed(0) +
                          '%)'}
                    </span>
                  </div>
                  {!!detailData.get('sendError') && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('sendError') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_40', defaultMessage: '열람' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('read') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                    </span>
                  </div>
                  {/* 링크 첨부 or 피싱 유도 */}
                  {(2 & detailData.get('linkAttach') || isPhishing) && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {/* 피싱 유도 */}
                        {4 === detailData.get('examType')
                          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                          : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('download') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {/* 피싱 유도 */}
                      {isPhishing
                        ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
                        : defineMessages(formatMessage({ id: 'ExamDetail_41', defaultMessage: '감염' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('infection') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                    </span>
                  </div>
                  {/* 피싱 유도가 아닐때 */}
                  {!isPhishing && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'ExamDetail_4', defaultMessage: '감염 PC' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('infectionPc') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_17', defaultMessage: '대' }))}
                      </span>
                    </div>
                  )}
                  {/* 피싱 유도가 아닐때 */}
                  {!isPhishing &&
                    /* 모의 악성파일 */
                    (1 === detailData.get('examType') &&
                      2 === detailData.getIn(['attachData', 'attachExamType']) && (
                        <div className={cx('examInfo')}>
                          <span className={cx('examInfo-title')}>
                            {defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' }))}
                          </span>
                          <span className={cx('examInfo-content')}>
                            {detailData.get('cure') +
                              ' ' +
                              defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      ))}
                  {/* 신고 하기 */}
                  {commonVar.isDeclare === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('declare') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  {/* 교육 하기 */}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_20', defaultMessage: '연결된 교육' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('edu') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_21', defaultMessage: '교육 대상자' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduTarget') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  {/* {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>{'교육 진행전'}</span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduBefore') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>{'교육 진행중'}</span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduPlay') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>{'교육 완료'}</span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduAfter') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )} */}
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_42', defaultMessage: '등록일' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {common.timeFormatFromUTCEpoch(detailData.get('regEpoch'))}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetail_43', defaultMessage: '마지막 수정일' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {common.timeFormatFromUTCEpoch(detailData.get('modifyEpoch'))}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {/* ----------------------------------------- 감염 가능 파일 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-infectionFile')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-infectionFile', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetail_2', defaultMessage: '감염 가능 파일' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>{InfectionFile}</div>
              </div>
            )}
            {/* ----------------------------------------- 감염 대상 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-target')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-target', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetail_3', defaultMessage: '감염 대상' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingTarget && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {InfectionTargetComponent}
                  {infectionTarget.get('totalPage') > 1 &&
                    infectionTarget.get('totalPage') > infectionTarget.get('page') && (
                      <div className={cx('bt-addView')} onClick={() => onGetInfectionFile()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'ExamDetail_44', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 감염 PC ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-pc')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-pc', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetail_4', defaultMessage: '감염 PC' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingPC && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {InfectionPcComponent}
                  {infectionPC.get('totalPage') > 1 &&
                    infectionPC.get('totalPage') > infectionPC.get('page') && (
                      <div className={cx('bt-addView')} onClick={() => onGetInfectionPC()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'ExamDetail_44', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 교육 이력 ----------------------------------------- */}
            {commonVar.isEdu === 1 && (
              <div className={cx('element')}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {/* {defineMessages(formatMessage({ id: 'ExamDetail_30', defaultMessage: '훈련 정보' }))} */}
                    {defineMessages(formatMessage({ id: 'Edu_22', defaultMessage: '교육 이력' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingEdu && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {EduListComponent}
                  {eduList.get('totalPages') > 1 &&
                    eduList.get('totalPages') > eduList.get('page') &&
                    eduList.get('data').size > 0 && (
                      <div className={cx('bt-addView')} onClick={() => onGetEduHistory()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'TargetDetail_29', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

export default injectIntl(ExamDetail);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamDetail.js